import ShopifyObject from './ShopifyObject';
import CartItem from './CartItem';

export default class Cart extends ShopifyObject {
  /**
   * @param {ShopifyProductOption} cart
   */
  constructor(cart) {
    super(cart.id);

    this._token = cart.token || '';
    this._note = cart.note || null;
    this._attributes = cart.attributes || [];
    this._originalTotalPrice = cart.original_total_price || 0;
    this._totalPrice = cart.total_price || 0;
    this._totalDiscount = cart.total_discount || 0;
    this._totalWeight = cart.total_weight || 0;
    this._itemCount = cart.item_count || 0;
    this._requiresShipping = cart.requires_shipping || false;
    this._currency = cart.currency || 0;
    this._itemsSubtotalPrice = cart.items_subtotal_price || 0;
    this._cartLevelDiscountApplications =
      cart.cart_level_discount_applications || [];
    this._items = cart.items ? cart.items.map(item => new CartItem(item)) : [];
  }

  /**
   * @returns {string}
   */
  get token() {
    return this._token;
  }

  /**
   * @returns {string}
   */
  get note() {
    return this._note;
  }

  /**
   * @param {string}
   */
  set note(note) {
    this._note = note;
  }

  /**
   * @returns {Object}
   */
  get attributes() {
    return this._attributes;
  }

  /**
   * @param {Object}
   */
  set attributes(attributes) {
    this._attributes = attributes;
  }

  /**
   * @returns {number}
   */
  get originalTotalPrice() {
    return this._originalTotalPrice;
  }

  /**
   * @returns {number}
   */
  get totalPrice() {
    return this._totalPrice;
  }

  /**
   * @returns {number}
   */
  get totalDiscount() {
    return this._totalDiscount;
  }

  /**
   * @returns {number}
   */
  get totalWeight() {
    return this._totalWeight;
  }

  /**
   * @returns {number}
   */
  get itemCount() {
    return this._itemCount;
  }

  /**
   * @returns {CartItem[]}
   */
  get items() {
    return this._items;
  }

  /**
   * @returns {boolean}
   */
  get requiresShipping() {
    return this._requiresShipping;
  }

  /**
   * @returns {number}
   */
  get currency() {
    return this._currency;
  }

  /**
   * @returns {number}
   */
  get itemsSubtotalPrice() {
    return this._itemsSubtotalPrice;
  }

  /**
   * @returns {array}
   */
  get cartLevelDiscountApplications() {
    return this._cartLevelDiscountApplications;
  }

  /**
   *
   * @return {Object} - Shopify Cart Object.
   */
  JSON() {
    return {
      attributes: this.attributes,
      cart_level_discount_applications: this.cartLevelDiscountApplications,
      currency: this.currency,
      item_count: this.itemCount,
      items: this.items.map(item => item.JSON()),
      items_subtotal_price: this.itemsSubtotalPrice,
      note: this.note,
      original_total_price: this.originalTotalPrice,
      requires_shipping: this.requiresShipping,
      token: this.token,
      total_discount: this.totalDiscount,
      total_price: this.totalPrice,
      total_weight: this.totalWeight,
    };
  }
}
